const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountMaster(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M347.115 212.021V83.081M27.113 83.081v246.866c0 34.839 71.635 63.081 160.001 63.081 8.723 0 17.283-.275 25.627-.805",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#999999",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.114,
    cy: 83.081,
    rx: 160.001,
    ry: 63.081,
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#999999",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.339 259.375c-20.181 3.622-42.605 5.64-66.225 5.64-88.366 0-160.001-28.242-160.001-63.081",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#999999",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.48 411.768c7.334-16.59 11.407-34.938 11.407-54.236 0-74.264-60.31-134.468-134.706-134.468s-134.706 60.203-134.706 134.468S275.785 492 350.181 492c18.358 0 35.858-3.666 51.806-10.304M350.181 319.432v76.201M388.281 357.532h-76.2",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#999999",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMaster);
export default __webpack_public_path__ + "static/media/account-master.b175836ea0b6ea827740ea5cf8de4d6f.svg";
export { ForwardRef as ReactComponent };